import { Lead } from '../types/lead';
import { channelLabels } from '../data/options';
import { formatARS } from './format';

/** Resumen de la consulta para enviar al WhatsApp comercial. No incluye CUIL ni datos crediticios sensibles. */
export function leadWhatsAppText(lead: Lead): string {
  const lines = [
    `Hola VCARS, acabo de dejar una consulta en la web.`,
    `Código: ${lead.code}`,
    `Tipo: ${channelLabels[lead.channel]}`,
    `Nombre: ${lead.name}`,
    lead.phone ? `Teléfono: ${lead.phone}` : '',
    lead.email ? `Email: ${lead.email}` : '',
    lead.vehicleLabel ? `Vehículo: ${lead.vehicleLabel}` : '',
    lead.price ? `Precio: ${formatARS(lead.price)}` : '',
    lead.down ? `Anticipo: ${formatARS(lead.down)}` : '',
    lead.term ? `Plazo: ${lead.term} meses` : '',
    lead.simulation ? `Cuota estimada: ${formatARS(lead.simulation.installment)}` : '',
    lead.bank ? `Banco: ${lead.bank}` : '',
    lead.tradeIn ? `Usado: ${lead.tradeIn.brand} ${lead.tradeIn.model} ${lead.tradeIn.year}, ${lead.tradeIn.km.toLocaleString('es-AR')} km` : '',
    lead.credit ? `Anticipo disponible: ${lead.credit.downRange}` : '',
    lead.message ? `Mensaje: ${lead.message}` : '',
  ];
  return lines.filter(Boolean).join('\n');
}
